import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { colors } from "@/constants/colors.jsx";

const loanPurposes = [
  "Start a Business",
  "Expand Business",
  "Buy Equipment",
  "Working Capital",
  "Buy Inventory",
  "Refinance Debt",
  "Other Business Purpose"
];

const LoanPurposeStep = ({ onNext, initialValue = "" }) => {
  const [selectedPurpose, setSelectedPurpose] = useState(initialValue);

  return (
    <div className="flex flex-col min-h-[400px] md:min-h-[450px]">
      <div className="space-y-3 mb-6">
        <div className="text-center space-y-1">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">How do you plan to use your loan?</h2>
          <div className="w-12 h-0.5 mx-auto" style={{ backgroundColor: colors.primary[800] }}></div>
        </div>
      </div>

      <div className="flex-grow">
        <Select
          value={selectedPurpose}
          onValueChange={setSelectedPurpose}
        >
          <SelectTrigger 
            className="w-full text-base md:text-lg py-6 px-4 border-slate-200 focus:ring-2"
            style={{ 
              '--ring-color': `${colors.primary[800]}20`,
              '--ring-offset-color': colors.primary[800],
              '&:focus': {
                borderColor: colors.primary[800],
                boxShadow: `0 0 0 2px ${colors.primary[800]}20`
              }
            }}
          >
            <SelectValue placeholder="Select a purpose" />
          </SelectTrigger>
          <SelectContent>
            {loanPurposes.map((purpose) => (
              <SelectItem
                key={purpose}
                value={purpose}
                className="text-base cursor-pointer py-3 px-4"
                style={{ 
                  '&:hover': {
                    backgroundColor: `${colors.primary[800]}05`
                  },
                  '&:focus': {
                    backgroundColor: `${colors.primary[800]}05`
                  }
                }}
              >
                {purpose}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="mt-auto">
        <Button
          onClick={() => onNext(selectedPurpose)}
          disabled={!selectedPurpose}
          className="w-full text-white py-3 md:py-4 text-base md:text-lg font-semibold rounded-lg shadow-md hover:shadow-lg transition-all"
          style={{ 
            backgroundColor: colors.primary[800],
            '&:hover': {
              backgroundColor: `${colors.primary[800]}e6`
            }
          }}
          variant={selectedPurpose ? "default" : "secondary"}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default LoanPurposeStep; 